import type { ExpressDesignerImage } from 'data-layer';
import type { ImageInformation } from 'stores/express-designer';
import { IMAGE_SERVICE } from 'utils';

export function convertToImageInformation(img: ExpressDesignerImage): ImageInformation {
  return {
    id: img.id,
    uuid: img.id,
    urlThumbBig: `${IMAGE_SERVICE.PATH}${IMAGE_SERVICE.ENDPOINTS.THUMB_BIG_URL(img.id)}`,
    urlThumbSmall: `${IMAGE_SERVICE.PATH}${IMAGE_SERVICE.ENDPOINTS.THUMB_SMALL_URL(img.id)}`,
    width: img.width,
    height: img.height,
    rotatedWidth: img.rotatedWidth,
    rotatedHeight: img.rotatedHeight,
    isUpload: false,
    uploadDate: '',
  };
}
